export class AnalyticsEvent {
    public static DownloadChecks = 'download checks';
    public static EmailExport = 'email export';
    public static Export = 'export';
    public static InvoiceFilesUploaded = 'invoice files uploaded';
    public static MobileUploadSendSms = 'mobile invoice upload send sms';
    public static MobileUploadFilesUploaded = 'mobile sms files uploaded';
    public static WhatsNewEvent = 'whats new';
}

export class AnalyticsProp {
    public static FileType = 'fileType';
    public static ReportName = 'report name';
    public static WhatsNewTarget = 'target';
}

export class AnalyticsValue {
    public static AccountOverviewDate = 'account overview by date';
    public static AvailableFundsSummary = 'available funds summary';
    public static Aging = 'aging';
    public static AgingCustomer = 'aging by customer';
    public static Collections = 'collections';
    public static CollectionsByCustomer = 'collections by customer';
    public static CreditRequestHistory = 'credit request history';
    public static Customers = 'customers';
    public static CustomerSwitchedDetails = 'customer switched in details';
    public static Funding = 'funding';
    public static IncreaseCreditLimitCreditRequestHistory =
        'increase credit limit credit request history';
    public static InvoiceUploadHistory = 'invoice upload history';
    public static Ineligibles = 'ineligibles';
    public static IneligiblesCustomer = 'ineligibles by customer';
    public static Purchases = 'purchases';
    public static PurchasesCustomer = 'purchases by customer';
}
